import { ImageModal } from '../modal/image_modal';

export function OptionGallery(props) {
    return (
        <div className="options">
            <div className={'option-grid' + ' direction-' + props.direction}>
                {props.option.map(function (option, i) {
                    if (!option.material.includes(props.material.value)) {
                        return null;
                    }

                    const imgEl = (
                        <img
                            src={option?.image?.sizes?.medium}
                            alt={option?.title}
                            loading="lazy"
                            onClick={(e) => props.openImageModal(e, option)}
                            style={{ cursor: 'zoom-in' }}
                        />
                    );

                    if (props.direction === 'column') {
                        return (
                            <div key={i} className={ 'option' + (props.showMore && props.expand ? '' : ' collapse-accordion')}>
                                <h4>{option?.title}</h4>
                                <div className="option-content">
                                    {imgEl}
                                    <p dangerouslySetInnerHTML={{__html: option?.description}}></p>
                                </div>
                            </div>
                        );
                    }

                    let renderHTML = false;
                    let description = option?.description || '';
                    if (option?.description?.includes('[render_html]')) {
                        renderHTML = true;
                        description = option.description.replace('[render_html]','');
                    }

                    return (
                        <div key={i} className={'option' + (props.showMore && props.expand ? '' : ' collapse-accordion')}>
                            {imgEl}
                            <h4>{option?.title}</h4>
                            {renderHTML
                                ? (<p dangerouslySetInnerHTML={{__html: description,}}></p>)
                                : (<p>{description}</p>)}
                        </div>
                    );
                })}
            </div>

            {props.modalImage && <ImageModal modalImage={props.modalImage} closeModal={props.closeModal}></ImageModal>}
        </div>
    );
}